export const enum PolicyRole {
  PRIMARYNAMEDINSURED = 'primarynamedinsured',
  SECONDARYNAMEDINSURED = 'secondarynamedinsured'
}
